require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./rseaux-de-formation-internationaux-0-0-8.json") })
        }
      }, "path---rseaux-de-formation-internationaux-0-0-8");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---rseaux-de-formation-internationaux-0-0-8!./.cache/json/rseaux-de-formation-internationaux-0-0-8.json
// module id = 555
// module chunks = 231608221292675